export const sessions = [
  {
    id: 1,
    title: 'How I Clone Myself Using AI — 5 Years Later: From Research to $25M Heists',
    description: 'In 2020, I demonstrated at Black Hat how to create an AI clone of myself. Five years later, deepfake attackers stole $25M using a fake CFO on a Zoom call. See how the threat has evolved and how to defend against it.',
    type: 'Talk',
    date: '15 May 2026',
    time: '5:00 PM IST',
    duration: '40 min',
    attendees: 0,
    maxAttendees: 100,
    host: 'Tamaghna Basu',
    speakers: [
      {
        name: 'Tamaghna Basu',
        bio: 'Tamaghna Basu is the Founder & CEO of DeTaSECURE, a cybersecurity company specializing in AI, Web3, and application security. He originally presented "How I Clone Myself Using AI" at Black Hat USA 2020, predicting the rise of AI-powered social engineering attacks years before they became mainstream threats. With 20+ years of experience, including roles at PwC, eBay/PayPal, and Walmart Labs, Tamaghna has trained 1,000+ security professionals worldwide. He holds OSCP, GCIH, CEH, and ECSA certifications, mentors at Stanford University\'s Cybersecurity Program, and was actively involved in creating a 25,000+ member security community across seven countries.',
        photo: '/images/trainers/TamaghnaBasu.jpeg',
        designation: 'Founder & CEO',
        company: 'DeTaSECURE',
      },
    ],
    tags: ['AI Security', 'Deepfakes', 'Social Engineering'],
    status: 'upcoming',
    featured: true,
    popular: false,
  },
];
